import React, { useState } from 'react';
import './areq-sidebar.scss';
import { useModal, connectModal, Button } from '@gsa/afp-component-library';
import { WarnIcon } from '@/assets/images/warn-icon';
import AreqModal from '@/components/Areq/AreqModal/AreqModal';

const { appURLs } = window.AFP_CONFIG;

export default function AreqSidebar({ standardItem }) {
  const { isOpen, openModal, closeModal } = useModal();
  const DisplayModal = connectModal(AreqModal);
  const localStandardItem = standardItem?.standardItemNumber
      ? standardItem
      : JSON.parse(sessionStorage.getItem('standardItem'));
  const svgCode = localStandardItem?.vehicleTypeCode?.code?.concat('_black');
  const iconURL = `${appURLs.cdnUrl}/icons/sin-sub-category/${svgCode}.svg`;
  const [vehicleBodyIcon, setVehicleBodyIcon] = useState(iconURL);
  const handleIconError = () => {
      const iconURL = `${appURLs.cdnUrl}/icons/sin-sub-category/02.svg`;
      setVehicleBodyIcon(iconURL);
  };

  const openAreqModal = () => {
    openModal();
  };

  return (
    <div className="areq-sidebar">
      <DisplayModal isOpen={isOpen} onClose={closeModal} cancel={closeModal} />

      <div className="areq-sidebar-description">
        <h4 className="title">
          <div className="title-icon">
            <WarnIcon width={15} height={15} className="icon" />
          </div>
          <div className="title-text">This is an AREQ requisition</div>
        </h4>
        <p>
          The Additional Requirements (AREQ) option code allows customers to
          request specific open market equipment not listed in the Compare and
          Select page.
        </p>
        <p>
          Customers are required to provide information detailing their
          additional requirements before sending the requisitions to GSA for
          their review.
        </p>
        <Button
          variant="unstyled"
          label="Review complete AREQ process and instructions here"
          onClick={openAreqModal}
        />
      </div>

      <hr />

      <div className="vehicle-type">
          <img
              data-testid="veh-req-icon"
              className="vehicle-type-icon"
              src={vehicleBodyIcon}
              alt="ambulance icon"
              onError={() => handleIconError()}
          />
          <span>
              {localStandardItem?.standardItemNumber} -{' '}
              {localStandardItem?.title}
          </span>
      </div>
    </div>
  );
};